import { PureComponent } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import './Modal.css';

if (process.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('#root');
}

const propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

const defaultProps = {};

class Modal extends PureComponent {
  render() {
    const {
      children,
      className,
      isOpen,
      title,
      onAfterOpen,
      onRequestClose,
      ...otherProps
    } = this.props;

    return (
      <ReactModal
        className={clsx('Modal', className)}
        overlayClassName="ModalOverlay"
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        contentLabel={`${title} modal`}
        shouldCloseOnEsc={false}
        ariaHideApp={process.env.NODE_ENV !== 'test'}
        {...otherProps}
      >
        <button type="button" className="unstyled_btn" onClick={onRequestClose}>
          <i data-testid="modal-close-icon" className="Modal-x fas fa-times" />
        </button>
        <h2 data-testid="modal-title" className="Modal-heading">
          {title}
        </h2>
        {children}
      </ReactModal>
    );
  }
}

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
